// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"c7b9ab65","610":"0c541194","703":"9ecf8dd4","787":"c4e7f8f9"}[chunkId] + ".chunk.js";
};